// extracted by mini-css-extract-plugin
module.exports = {"container":"SaveSearch_container___JmN5"};